<template>
    <DFormRow
        :is-required="required"
        :label="__('customers.contracts.limited_runtime_in_month.label')"
        :error="errors.limited_runtime_in_month"
        :hint="__('customers.contracts.limited_runtime_in_month.hint')"
    >
        <DInput
            id="limited_runtime_in_month"
            :model-value="modelValue"
            :is-valid="isFormFieldValid('limited_runtime_in_month')"
            type="number"
            @update:modelValue="$emit('update:modelValue', $event)"
        />
    </DFormRow>
</template>

<script setup>
defineProps({
    errors: {
        type: Object,
        default: () => { return {} }
    },
    required: {
        type: Boolean,
        default: () => {
            return false
        }
    },
    modelValue: {
        type: [String, Number],
        default: null
    }
})

defineEmits(['update:modelValue'])

</script>

<style scoped lang="scss">

</style>
